<div class="container">
    <app-download-section></app-download-section>
</div>